import { Input } from "@/components/ui/input";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { selectCurrentRoom } from "@/context/features/room/roomSlice";
import { useSelector } from "react-redux";
import { toaster } from "@/utils/toaster";
const origin = import.meta.env.VITE_BIOARC_SERVICE || "https://bioarc.ir";

export default function FileDesc({
  serviceID,
  callback,
}: {
  serviceID: string;
  callback: () => void;
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [inputVal, setInputVal] = useState<string>("");
  const { focusedhash } = useSelector(selectCurrentRoom);
  const [actionLoading, setActionLoading] = useState(false);

  const onSubmitDesc = async () => {
    if (!focusedhash || !inputVal.trim() || !serviceID) {
      return;
    }
    try {
      setActionLoading(true);
      await fetch(`${origin}/VisitOnline/AjaxonFiledescription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: serviceID,
          hash: focusedhash,
          description: inputVal,
        }),
      });
      // const data = await res.json();
      setIsOpen(false);
      setInputVal("");
      callback();
      setActionLoading(false);
      toaster("info", "توضیحات اضافه شد");
    } catch (e) {
      setActionLoading(false);
      console.error(e);
    }
  };
  return (
    <div className="flex flex-col gap-2">
      <div className="grow flex justify-between">
        <AnimatePresence mode="wait" initial={false}>
          <h6 className="text-primary font-semibold">{t("description")}</h6>
          {isOpen ? (
            <motion.div
              key="close-icon"
              initial={{ opacity: 0, rotate: -90, scale: 0.8 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: 90, scale: 0.8 }}
              transition={{ duration: 0.1 }}
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <ChevronUp className="text-primary cursor-pointer" />
            </motion.div>
          ) : (
            <motion.div
              key="chevron-icon"
              initial={{ opacity: 0, rotate: 90, scale: 0.8 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: -90, scale: 0.8 }}
              transition={{ duration: 0.1 }}
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <ChevronDown className="text-primary cursor-pointer" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      {isOpen && (
        <div className="flex gap-1 items-center">
          <Input onChange={(e) => setInputVal(e.target.value)} />
          <Button
            variant={"default"}
            size={"sm"}
            onClick={onSubmitDesc}
            disabled={actionLoading}
          >
            {actionLoading ? (
              <div className="w-8 h-8 p-2 flex items-center justify-center ">
                <div className="w-full h-full border-2 border-background border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              t("submit")
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
